import { FC, useEffect } from "react";

interface SummaryAdditionalServicesModalProps {
  isOpen: boolean;
  onClose: () => void;
  services: string[];
}

const SelectedParticipantAdditionalServicesModal: FC<
  SummaryAdditionalServicesModalProps
> = ({ isOpen, onClose, services }) => {
  // Close modal if click happens outside of the modal content
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      // Check if the click target is outside the modal content
      const modalContent = document.getElementById("modal-content");
      if (modalContent && !modalContent.contains(e.target as Node)) {
        onClose(); // Close modal if clicked outside
      }
    };

    // Attach event listener to detect outside clicks
    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    // Cleanup event listener on unmount or when modal is closed
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
      <div
        id="modal-content"
        className="bg-white p-6 rounded-lg shadow-lg w-1/2 flex flex-col items-center"
      >
        <h2 className="text-xl font-semibold mb-4 text-center">
          Doplňkové služby
        </h2>
        <ul className="text-center">
          {services.length > 0 ? (
            services.map((service, index) => (
              <li key={index} className="mb-2">
                {service}
              </li>
            ))
          ) : (
            <li>žádné</li>
          )}
        </ul>
        <button
          className="mt-4 bg-blue-600 text-white px-4 py-2 rounded"
          onClick={onClose}
        >
          Zavřít
        </button>
      </div>
    </div>
  );
};

export default SelectedParticipantAdditionalServicesModal;
